import Vue from 'vue';
import addressTransformer from './../../transformers/address';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('getAddress', addressTransformer.fetch(data));

  resolve(addressTransformer.fetch(data));
};

const failed = () => {};

export default () => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.get('addresses')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/address/show.js